import { render, staticRenderFns } from "./processInspectionMatch.vue?vue&type=template&id=15998d2e&scoped=true"
import script from "./processInspectionMatch.vue?vue&type=script&lang=js"
export * from "./processInspectionMatch.vue?vue&type=script&lang=js"
import style0 from "./processInspectionMatch.vue?vue&type=style&index=0&id=15998d2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15998d2e",
  null
  
)

export default component.exports